// extracted by mini-css-extract-plugin
export default {"defaultCard":"jn-z","otherCards":"kn-z","empty":"ln-z","addNewItem":"mn-z","disabled":"nn-z","cardGrid":"on-z"};